/**
 * @class ExampleComponent
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { StyledParagraph } from './Typestack.styles'

export default class Paragraph extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['lg', 'md', 'sm'])
  }

  render() {
    const {
      children,
      componentProp,
      size,
      ...rest
    } = this.props

    const Component = StyledParagraph(componentProp)

    return (
      <Component size={size} {...rest}>
        {children}
      </Component>
    )
  }
}
